import { render } from "./CommissionInvoices.vue?vue&type=template&id=be2b71bc"
import script from "./CommissionInvoices.vue?vue&type=script&lang=js"
export * from "./CommissionInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__